import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';
import {Material} from "../types/Material";

export const useGetMaterials = (dealerID: number, zipCode: string) => {
    const { data, isLoading } = useQuery({
        queryKey: ['ee-pro-materials', dealerID, zipCode],
        enabled: dealerID > 0,
        queryFn: async () => await apiClient.get('ee-pro/materials?dealerID=' + dealerID + '&zipCode=' + zipCode) as Material[]
    });

    return {
        data: data || [],
        isLoading: isLoading
    };
};
